



















import ApiSearch from "@/components/apiSearch/components/ApiSearch.vue";

import Vue from "vue";
import { ApiSearchColumn } from "@/components/apiSearch/models/ApiSearch";
import ProjectHeadDTO from "@/modules/projectHead/models/ProjectHeadDTO";
import { FilteringModel } from "@/services/filtering";
import http, { handleApiResponse, handleApiResponseWithSuccess } from "@/services/http";
import ApiResponse from "@/models/ApiResponse";
import { t } from "@/plugins/i18n";


interface Data {
  filter: FilteringModel;
  itemText: string;
  projectStatuses: any[] | null;
  loading: boolean;
}

interface Methods {
  selected(project: ProjectHeadDTO): void;
  getProjectStatusName(projectStatus: number): string;
}

interface Computed {
  id: number;
  url: string;
  columns: ApiSearchColumn[];
}

interface Props {
  initId: number;
  invGroupType: number;
  disabled: boolean;
}


export default Vue.extend<Data, Methods, Computed, Props>({
  components: { ApiSearch },

  async beforeMount() {
    this.loading = true;
    this.projectStatuses = await http.get<ApiResponse<any[]>>(`project-head/statuses`)
      .then(handleApiResponse);
    this.itemText = this.$props.invGroupType === 2 ? "partnerName" : "name";
    this.filter = new FilteringModel().value("invGroupType", this.$props.invGroupType);
    this.loading = false;
  },

  props: {
    initId: { type: Number },
    /** 2: profitcentrum, 3: költségcentrum @default 1 */
    invGroupType: { type: Number, default: 1 },
    disabled: {type: Boolean, default: false}
  },

  data() {
    return {
      filter: new FilteringModel(),
      itemText: "name",
      projectStatuses: null as null | any[],
      loading: false,
    };
  },

  methods: {
    selected(project) {
      this.$emit("change", project);
    },
    getProjectStatusName(projectStatus) {
      return this.projectStatuses?.find((x) => x.id == projectStatus)?.name ?? "";
    }
  },

  computed: {
    id() {
      return this.$props.initId ?? 1;
    },
    url() {
      return "project-head/search";
    },
    columns: function() {
      return [
        {
          field: "name",
          title: t("Projekt")
        },
        {
          field: "mainCode",
          title: t("ProjektKod")
        },
        {
          field: "code",
          title: t("ProjektKulsoKod")
        },
        {
          field: "poWorkNumber",
          title: t("Munkaszam")
        },
        {
          field: "poNumber",
          title: t("InvoiceItemDimension_Megrendelesszam")
        },
        {
          field: "poExtCode",
          title: t("InvoiceItemDimension_MegrLevelszam")
        },
        {
          field: "partnerName",
          title: t("Partner")
        },
        {
          field: "partnerExtCode",
          title: t("InvoiceItemDimension_PartnerKulsoKod")
        },
        {
          field: "status",
          title: t("InvoiceItemDimension_ProjektStatusz"),
          cell: "status",
          multiselect: true,
          multiselectField: "selectedProjectStatuses",
          multiselectOptions: this.projectStatuses?.map((x) => ({
            text: x.name,
            value: x.id,
          })),
        },
      ]
    },
  },
});
